export const AMPLITUDE = {
  TYPE: {
    START: 'TrackStartApplication',
    ACTION: 'TrackAction',
  },
  EVENT: {
    LOAD: {
      ATTRIBUTES: 'Load Attributes Page',
    },
    CLICK: {
      ETIQUETAS: 'Click To Tags',
      CONFIRMATION: 'Click To Confirmation',
      SUMMARY: 'Click To Summary',
      ASSIGNMENT: 'Click To Assignment Tags',
      UPLOAD_USERS: 'Click To Upload Users',
      MANAGE_ATTRIBUTES: 'Click To Manage Attributes',
    },
  },
  PAGE: {
    ATTRIBUTES: 'Attributes',
    USER_UPLOAD: 'User Upload',
  },
};
